'use client';

import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { signOut } from 'next-auth/react';
import { useEffect } from 'react';

import { getLastLoginPathCookie } from '@/component/feature/auth/lastLoginPathCookie';
import { MobileFirstAppLayout } from '@/component/layout/MobileFirstAppLayout/MobileFirstAppLayout';
import { Column } from '@/component/parts/layout/Column/Column';
import { Spinner } from '@/component/parts/placeholder/Spinner/Spinner';
import { Heading } from '@/component/parts/typography/Heading/Heading';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      throwOnError: true,
    },
  },
});

function Page() {
  const { isLoading, data } = useQuery({
    queryKey: ['last-login-path'],
    queryFn: getLastLoginPathCookie,
  });

  useEffect(() => {
    (async () => {
      if (isLoading) {
        return;
      }

      if (data) {
        await signOut({
          redirect: true,
          callbackUrl: data,
        });
      } else {
        await signOut();
      }
    })();
  }, [isLoading, data]);

  return (
    <MobileFirstAppLayout>
      {!isLoading && !data && (
        <Column spacing="30px">
          <Heading as="h2" size="larger" marginTop="10px">
            ログインが必要です
          </Heading>
          {(isLoading || data) && <Spinner />}
        </Column>
      )}
    </MobileFirstAppLayout>
  );
}

export function UnauthorizedPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <Page />
    </QueryClientProvider>
  );
}
